/**
 * Available indexes reducer.
 * @module actions/availableIndexes/availableIndexes
 */

import { Buffer } from 'buffer';
import {
  GET_AVAILABLE_INDEXES,
  AVAILABLE_INDEXES_CLEAR_SSR,
} from '@fhnw/constants/ActionTypes';

interface AvailableIndexesProps {
  query?: Array<{
    i: string;
    o: string;
    v?: string | string[];
  }>;
  filters?: string[];
  activeFilters?: { [key: string]: string | string[] };
}

export function getSubrequest(path: string, data?: AvailableIndexesProps) {
  return Buffer.from(`${path}|${JSON.stringify(data || {})}`).toString(
    'base64',
  );
}

/**
 * Get available indexes.
 * @function getAvailableIndexes
 * @param {string} path Content path.
 * @param {Object} data Query and filters data.
 * @param {boolean} isSSR Whether the request is from SSR.
 * @returns {Object} Get available indexes action.
 */
export function getAvailableIndexes(
  path: string,
  data?: AvailableIndexesProps,
  isSSR = false,
) {
  const subrequest = getSubrequest(path, data);
  const qsa = `?data=${encodeURIComponent(Buffer.from(JSON.stringify(data || {})).toString('base64'))}`;
  if (qsa.length + path.length > 2048) {
    return {
      type: GET_AVAILABLE_INDEXES,
      subrequest,
      request: {
        op: 'post',
        path: `${path}/@available-indexes`,
        data,
      },
      isSSR,
    };
  }
  return {
    type: GET_AVAILABLE_INDEXES,
    subrequest,
    request: {
      op: 'get',
      path: `${path}/@available-indexes${qsa}`,
    },
    isSSR,
  };
}

/**
 * Clear SSR flag for available indexes.
 * @function availableIndexesClearSSR
 * @param {string} subrequest Subrequest key.
 * @returns {Object} Clear SSR action.
 */
export const availableIndexesClearSSR = (subrequest: string) => ({
  type: AVAILABLE_INDEXES_CLEAR_SSR,
  subrequest,
});
